import { TRANSFORM_ENTITIES } from './constants';

export const setIgnoreRedirectInSubscription = (ignore) => {
  return (dispatch) => {
    return dispatch({
      type: TRANSFORM_ENTITIES,
      payload: {
        subscriber: {
          subscription: {
            ignoreRedirect: ignore
          }
        }
      }
    });
  };
};

